<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  inheritAttrs: false,
});
</script>
<script setup lang="ts">

// "elevated" does not make sense for a three-dot menu button
import type { SiffletButtonSize } from '@/components/SButton/SButton.vue';

type SiffletThreeDotMenuButtonVariant = 'outlined' | 'text'

interface Props {
  /**
   * Whether the menu is disabled or not.
   */
  disabled?: boolean;
  /**
   * Button variant (`outlined` or `text`). `outlined` by default.
   */
  variant?: SiffletThreeDotMenuButtonVariant;
  /**
   * data-track attribute for testing purposes.
   */
  dataTrack?: string;
  size?: SiffletButtonSize;
}
defineProps({
  disabled: { type: Boolean, default: false },
  variant: { default: 'outlined' },
  dataTrack: null,
  size: { default: 'default' }
});

;
</script>

<template lang="pug">
//- The click event is stopped/prevent here to keep the default behavior (of context menu auto-closing) while preventing the click event from bubbling up to the parent element.
div( v-if="$slots.default" @click.stop.prevent )
  v-menu(
    content-class="border-around"
    nudge-bottom="5" nudge-right="36" min-width="200"
    transition="slide-x-reverse-transition"
    offset-x offset-y bottom left )
    template(#activator='{ on }')

      SButton(
        v-on="on"
        :disabled="disabled"
        color="secondary"
        :variant="variant"
        icon="icon-menu-dots-vertical"
        :size="size"
        :data-track="dataTrack")

    v-list.py-0(dense)
      slot
</template>
